export default function Spinner() {
  return <div className="spinner"></div>;
}
